import { render, staticRenderFns } from "./NewTermsConditionsModal.vue?vue&type=template&id=60eb6dd9"
import script from "./NewTermsConditionsModal.vue?vue&type=script&lang=js"
export * from "./NewTermsConditionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports